export default {
  GET_SEVENTH_NIGHT_PAGE_INFO: '/MagpieFestival/GetLandingPageInfo',
};
